<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-img :src="bigLogo" :aspect-ratio="16 / 9" contain min-height="32px" />
      <v-card class="elevation-12">
        <v-form @submit.prevent="submit">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>
              Logowanie
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <LoginBreadcrumb />
            <v-alert v-if="alreadySignedIn" type="error" width="100%" dense>
              <div>UWAGA! Ktoś już jest zalogowany na Twoim koncie.</div>
              <div>Upewnij się czy ktoś nie posiada Twojego loginu i hasła.</div>
            </v-alert>
            <v-alert v-if="alreadySignedIn" type="info" width="100%" dense>
              <div>Możesz ponownie zalogować się do systemu.</div>
            </v-alert>
            <v-alert v-if="responseError" type="error">
              {{ responseError }}
            </v-alert>
            <v-text-field
              v-model.trim="form.email"
              placeholder="E-mail"
              name="e-mail"
              prepend-icon="mdi-email"
              type="text"
              :error-messages="emailErrors"
              @input="$v.form.email.$touch()"
              @blur="$v.form.email.$touch()"
            />
            <v-text-field
              id="password"
              v-model.trim="form.password"
              placeholder="Hasło"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
              :error-messages="passwordErrors"
              @input="$v.form.password.$touch()"
              @blur="$v.form.password.$touch()"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn type="submit" color="primary" :loading="submitting">Zaloguj się</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required /*, email*/ } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';
import LoginBreadcrumb from '@/components/breadcrumbs/LoginBreadcrumb.vue';
import TenantSessionService from '@/services/tenantSessionService';

const { mapActions: mapAccountActions } = createNamespacedHelpers('account');
const { mapState: mapAppSettingsState, mapActions: mapAppSettingsActions } = createNamespacedHelpers('appSettings');

export default {
  components: {
    LoginBreadcrumb
  },
  mixins: [validationMixin],
  data: function() {
    return {
      form: {
        email: '',
        password: ''
      },
      responseError: '',
      submitting: false
    };
  },
  computed: {
    ...mapAppSettingsState({
      settingTenantName: state => state.tenantName,
      bigLogo: state => state.bigLogo || require('@/assets/logo-start.png')
    }),
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) {
        return errors;
      }
      if (!this.$v.form.email.required) {
        errors.push('Adres e-mail jest wymagany');
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) {
        return errors;
      }
      if (!this.$v.form.password.required) {
        errors.push('Hasło jest wymagane');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    },
    tenancyName() {
      return this.$route.query.t;
    },
    alreadySignedIn() {
      return this.$route.query.alreadySignedIn;
    }
  },
  validations: {
    form: {
      email: { required },
      password: { required }
    }
  },
  mounted() {
    let tenantName = this.tenancyName;
    if (!this.tenancyName) {
      const lastTenant = TenantSessionService.getLastTenant();
      if (lastTenant) {
        tenantName = lastTenant;
        this.$router.replace({ path: '/login', query: { t: lastTenant, alreadySignedIn: this.alreadySignedIn } });
      }
    }

    if (!this.settingTenantName || this.settingTenantName !== this.tenancyName) {
      this.loadAppSettings({
        tenantName: tenantName
      });
    }
  },
  methods: {
    ...mapAccountActions(['signIn']),
    ...mapAppSettingsActions(['loadAppSettings']),
    async submit() {
      this.$v.$touch();
      this.responseError = '';

      if (this.formValid) {
        this.submitting = true;
        const result = await this.signIn({
          email: this.form.email,
          password: this.form.password,
          tenancyName: this.tenancyName
        });

        this.submitting = false;
        if (result) {
          try {
            await this.$router.replace('/');
          } catch (e) {
            // duplicate path
          }
        } else {
          this.form.password = '';
          this.$v.form.password.$reset();
          this.responseError =
            'Nieprawidłowy adres e-mail lub hasło. Upewnij się czy nie został wcisnięty klawisz "Caps lock".';
        }
      }
    }
  }
};
</script>
